import { Pipe, PipeTransform } from '@angular/core'

/* Kendo MaskedTextBox mask for US phone numbers; bound value stays digits only */
export const PHONE_MASK = '000-000-0000'

/* Strip legacy formatting like "(919) 555-1212" so stored values fill PHONE_MASK cleanly */
export function toPhoneDigits(value: any): any {
  return value === null || value === undefined ? value : String(value).replace(/\D/g, '')
}

@Pipe({
    name: 'phone',
    standalone: true
})
export class PhonePipe implements PipeTransform {
  transform(input: any): any {
    if (input === null || input === undefined) {
      return input
    }
    const digits = String(input).replace(/\D/g, '')
    return digits.length === 10
      ? `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`
      : input
  }
}
